import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const StyledImg = styled.img`
    ${media.max.md`
        width: 160px;
        height: 50px;
    `}
`;
